import type { TransportMode } from "@/shared/contracts";
import { MapAnchor } from "@/shared/map";
import { legTitle, modeLabel, vehicleAnchorAt, currentLeg } from "@/shared/journey/vehicle";
import type { JourneyOverlayProps } from "@/shared/slots/names";
import { Icon, type IconName } from "@/shared/ui";
import "./transport.css";

const MODE_ICON: Record<TransportMode, IconName> = {
  flight: "plane",
  train: "train",
  ferry: "ship",
  drive: "car",
  // 出租车、公共交通、步行用 UI-ASSET-015 的 taxi、metro、walk（v2 三只爪印的轨迹）；原来分别借用小汽车、火车、定位针
  taxi: "taxi",
  transit: "metro",
  walk: "walk",
};


/** VehicleMarker：交通工具沿路线移动（位置由服务器时间与时间线决定），点击打开班次卡。 */
export function VehicleMarker({ mode, heading, label, onOpen }: { mode: TransportMode; heading: number; label: string; onOpen: () => void }) {
  const rotate = mode === "flight" ? heading : 0;
  return (
    <button type="button" className={`ps-vehicle ps-vehicle--${mode}`} data-map-interactive data-testid="vehicle-marker" aria-label={label} onClick={onOpen}>
      <span className="ps-vehicle__glow" aria-hidden="true" />
      <span className="ps-vehicle__icon" style={{ transform: `rotate(${rotate}deg)` }}>
        {/* 交通方式认不出（REL-02 3.4）：用通用的“旅途”图标，不画空图标 */}
        <Icon name={MODE_ICON[mode] ?? "journey"} size={24} strokeWidth={1.9} />
      </span>
    </button>
  );
}

export function VehicleLayer({ snapshot, nowMs, openSheet }: JourneyOverlayProps) {
  const leg = currentLeg(snapshot);
  const anchor = vehicleAnchorAt(snapshot, nowMs);
  if (!leg || !anchor) return null;
  return (
    <MapAnchor at={anchor.point} z={2}>
      <VehicleMarker
        mode={leg.mode}
        heading={anchor.heading}
        label={`${[leg.world_service ? modeLabel(leg.mode) : null, legTitle(leg)].filter(Boolean).join(" ")}：查看行程卡`}
        onOpen={() => openSheet("leg", leg.leg_id)}
      />
    </MapAnchor>
  );
}

export { MODE_ICON };
